import { styled } from "@pigment-css/react";

// Chat scroll container: expects the sticky header as its first child so messages scroll under
// the translucent gradient, and reserves the fixed dock's height as bottom padding via the shared var.
export const MessageViewport = styled("div")(({ theme }) => ({
  flex: 1,
  minHeight: 0,
  display: "flex",
  flexDirection: "column",
  // Uniform 24px rhythm: sticky header -> first message AND message -> message, since the header
  // and each message row are direct flex children.
  gap: theme.fieldSalesTwo.spacing[24],
  overflowY: "auto",
  // Reserve the dock height + a 32px cushion so the last block always rests 32px above the input.
  paddingBottom: `calc(var(--bottom-nav-opaque-height, 0px) + ${theme.fieldSalesTwo.spacing[32]})`,
}));

export const UserRow = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "flex-end",
  width: "100%",
  padding: `0 ${theme.fieldSalesTwo.spacing[20]}`,
}));

export const UserBubble = styled("article")(({ theme }) => ({
  maxWidth: "280px",
  padding: `${theme.fieldSalesTwo.spacing[10]} ${theme.fieldSalesTwo.spacing[16]}`,
  borderRadius: theme.fieldSalesTwo.radius[20],
  // Figma user-bubble fill rgba(19,19,19,0.04) — no exact neutral token (200 = 0.08).
  background: "rgba(19,19,19,0.04)",
  fontFamily: theme.fieldSalesTwo.font.family,
  fontSize: theme.fieldSalesTwo.font.size[15],
  fontWeight: theme.fieldSalesTwo.font.weight[500],
  lineHeight: theme.fieldSalesTwo.font.lineHeight[148],
  letterSpacing: theme.fieldSalesTwo.font.letterSpacing.subtle,
  color: theme.fieldSalesTwo.colors.neutral[900],
  wordBreak: "break-word",
}));

export const AssistantRow = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  width: "100%",
  padding: `0 ${theme.fieldSalesTwo.spacing[20]}`,
  color: theme.fieldSalesTwo.colors.neutral[900],
}));

// Flex column owns the block rhythm: an exact, collapse-proof 16px between every markdown block
// (paragraph ↔ heading ↔ list). Block-level margins are zeroed in MarkdownRenderer so only this gap applies.
export const MessageBody = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.fieldSalesTwo.spacing[16],
  minWidth: 0,
  // Let flex children shrink to the container instead of forcing horizontal overflow
  // (e.g. wide tables / long unbreakable tokens).
  "& > *": { minWidth: 0 },
}));
